import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect as RouterRedirect, useLocation } from 'react-router';

import type { RoutingKey } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { generatePath } from '@swf/core/utils/paths';

interface Props {
  routingKey: RoutingKey;
  values?: Record<string, string | number | boolean | undefined>;
}

const Redirect: React.FC<Props> = ({ routingKey, values = {} }) => {
  const { routes } = useSelector(select.page.getMeta);
  const { search } = useLocation();
  if (!routes?.[routingKey]) return null;

  let redirectRoute = generatePath(routes[routingKey], values);
  if (search) {
    redirectRoute = `${redirectRoute}${search}`;
  }
  return <RouterRedirect to={redirectRoute} />;
};

export default Redirect;
